import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { KeyboardComponent } from "./components/KeyboardComponent";
import { KeypadComponent } from "./components/KeypadComponent";
import { DragonHeadComponent } from "./components/DragonHeadComponent";
import { InventoryComponent } from "./components/InventoryComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-keyboard", KeyboardComponent);
window.customElements.define("game-keypad", KeypadComponent);
window.customElements.define("game-dragonhead", DragonHeadComponent);
window.customElements.define("inventory-component", InventoryComponent);
